import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Box, Text, tombac } from 'tombac';
import { AcceptIcon, WarningIcon } from 'tombac-icons';
import { transferUser } from "../api/organizationsApi";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AcceptWrapper = styled(Box).withConfig({
  displayName: "EmailPage__AcceptWrapper"
})(["display:flex;align-items:center;justify-content:center;"]);
const InvitationConfirmation = styled(Box).withConfig({
  displayName: "EmailPage__InvitationConfirmation"
})(["display:inline-flex;flex-direction:column;align-items:center;gap:", ";"], tombac.space(3));
const InvitationAcceptIon = styled(AcceptIcon).withConfig({
  displayName: "EmailPage__InvitationAcceptIon"
})(["color:", ";"], tombac.color('success', 500));
const InvitationWarningIcon = styled(WarningIcon).withConfig({
  displayName: "EmailPage__InvitationWarningIcon"
})(["color:", ";"], tombac.color('alert', 500));
const InvitationPrimaryText = styled(Text).withConfig({
  displayName: "EmailPage__InvitationPrimaryText"
})(["font-size:32px;font-weight:900;"]);
const InvitationSecondaryText = styled(Text).withConfig({
  displayName: "EmailPage__InvitationSecondaryText"
})(["font-size:24px;color:", ";"], tombac.color('neutral', 700));
export const EmailPage = () => {
  const [error, setError] = useState(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const linkId = searchParams.get('linkId');
  const handleTransfer = () => {
    transferUser(linkId).then(response => {
      if (response.error) {
        setError(true);
      } else {
        setError(false);
      }
    });
  };
  useEffect(() => {
    handleTransfer();
  }, [linkId]);
  return /*#__PURE__*/_jsxs(AcceptWrapper, {
    $backgroundColor: "#FFFFFF",
    "data-sentry-element": "AcceptWrapper",
    "data-sentry-component": "EmailPage",
    "data-sentry-source-file": "EmailPage.tsx",
    children: [error === null && /*#__PURE__*/_jsx(_Fragment, {}), error === false && /*#__PURE__*/_jsxs(InvitationConfirmation, {
      $padding: "5sp",
      children: [/*#__PURE__*/_jsx(InvitationAcceptIon, {
        size: 3
      }), /*#__PURE__*/_jsx(InvitationPrimaryText, {
        children: "The invitation has been accepted"
      })]
    }), error && /*#__PURE__*/_jsxs(InvitationConfirmation, {
      $padding: "5sp",
      children: [/*#__PURE__*/_jsx(InvitationWarningIcon, {
        size: 3,
        onClick: handleTransfer
      }), /*#__PURE__*/_jsx(InvitationPrimaryText, {
        children: "There was a problem with your invitation"
      }), /*#__PURE__*/_jsx(InvitationSecondaryText, {
        children: "Please, contact your distributor"
      })]
    })]
  });
};